import { render, staticRenderFns } from "./sort.vue?vue&type=template&id=1d7a306c"
import script from "./sort.vue?vue&type=script&lang=js"
export * from "./sort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports